import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import * as permissionKind from '../../../../shared/permissions';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import ConsentsAndDeclarationsList from './ConsentsAndDeclarationsList';

const ConsentsAndDeclarationsPage = () => {
    const { t } = useTranslation('consentsAndDeclarations');
    const navigate = useNavigate();
    const company = useCompany(true);

    const extra = (!company || hasPermissions(company?.permissions, [permissionKind.createAgreement])) && (
        <Button icon={<PlusOutlined />} onClick={() => navigate('/admin/consents/add')} type="primary">
            {t('consentsAndDeclarations:actions.newConsentsAndDeclarations')}
        </Button>
    );

    return (
        <ConsolePageWithHeader extra={extra} title={t('consentsAndDeclarations:title')}>
            <ConsentsAndDeclarationsList />
        </ConsolePageWithHeader>
    );
};

export default ConsentsAndDeclarationsPage;
